import { render, staticRenderFns } from "./StudentLearningRecordPage.vue?vue&type=template&id=40b4659a"
import script from "./StudentLearningRecordPage.vue?vue&type=script&lang=js"
export * from "./StudentLearningRecordPage.vue?vue&type=script&lang=js"
import style0 from "./StudentLearningRecordPage.vue?vue&type=style&index=0&id=40b4659a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports